import selectVideo from '../../../shared/video_contents/selectVideo'
import videoPlayer from '../../../shared/videoPlayer'
import directUploadVideoFile from '../../../shared/directUploadVideoFile'

export default function() {
  selectVideo();
  videoPlayer();
  directUploadVideoFile('/creator/video_contents/execute_presigned_post');
};
